import { __ } from '@wordpress/i18n'
import { getLangCode } from 'scripts/utils'

export const countries = {
  ...(getLangCode() === 'de-ch'
    ? { Schweiz: __('Schweiz', 'dhsv_theme') }
    : {}),
  Deutschland: __('Deutschland', 'dhsv_theme'),
  Österreich: __('Österreich', 'dhsv_theme'),
  ...(getLangCode() !== 'de-ch'
    ? { Schweiz: __('Schweiz', 'dhsv_theme') }
    : {}),
  Argentinien: __('Argentinien', 'dhsv_theme'),
  Australien: __('Australien', 'dhsv_theme'),
  Belgien: __('Belgien', 'dhsv_theme'),
  'Bosnien und Herzegowina': __('Bosnien und Herzegowina', 'dhsv_theme'),
  Brasilien: __('Brasilien', 'dhsv_theme'),
  Bulgarien: __('Bulgarien', 'dhsv_theme'),
  Chile: __('Chile', 'dhsv_theme'),
  China: __('China', 'dhsv_theme'),
  'Costa Rica': __('Costa Rica', 'dhsv_theme'),
  Dänemark: __('Dänemark', 'dhsv_theme'),
  Estland: __('Estland', 'dhsv_theme'),
  Finnland: __('Finnland', 'dhsv_theme'),
  Frankreich: __('Frankreich', 'dhsv_theme'),
  Griechenland: __('Griechenland', 'dhsv_theme'),
  Großbritannien: __('Großbritannien', 'dhsv_theme'),
  Hongkong: __('Hongkong', 'dhsv_theme'),
  Indien: __('Indien', 'dhsv_theme'),
  Indonesien: __('Indonesien', 'dhsv_theme'),
  Irland: __('Irland', 'dhsv_theme'),
  Island: __('Island', 'dhsv_theme'),
  Israel: __('Israel', 'dhsv_theme'),
  Italien: __('Italien', 'dhsv_theme'),
  Japan: __('Japan', 'dhsv_theme'),
  Kanada: __('Kanada', 'dhsv_theme'),
  Kasachstan: __('Kasachstan', 'dhsv_theme'),
  Kokosinseln: __('Kokosinseln', 'dhsv_theme'),
  Kolumbien: __('Kolumbien', 'dhsv_theme'),
  'Republik Korea': __('Republik Korea', 'dhsv_theme'),
  Kosovo: __('Kosovo', 'dhsv_theme'),
  Kroatien: __('Kroatien', 'dhsv_theme'),
  Lettland: __('Lettland', 'dhsv_theme'),
  Liechtenstein: __('Liechtenstein', 'dhsv_theme'),
  Litauen: __('Litauen', 'dhsv_theme'),
  Luxemburg: __('Luxemburg', 'dhsv_theme'),
  Malaysia: __('Malaysia', 'dhsv_theme'),
  Malta: __('Malta', 'dhsv_theme'),
  Mazedonien: __('Mazedonien', 'dhsv_theme'),
  Mexiko: __('Mexiko', 'dhsv_theme'),
  Mikronesien: __('Mikronesien', 'dhsv_theme'),
  Neuseeland: __('Neuseeland', 'dhsv_theme'),
  Niederlande: __('Niederlande', 'dhsv_theme'),
  'Niue Inseln': __('Niue Inseln', 'dhsv_theme'),
  Norwegen: __('Norwegen', 'dhsv_theme'),
  Peru: __('Peru', 'dhsv_theme'),
  Philippinen: __('Philippinen', 'dhsv_theme'),
  Polen: __('Polen', 'dhsv_theme'),
  Portugal: __('Portugal', 'dhsv_theme'),
  Ruanda: __('Ruanda', 'dhsv_theme'),
  Rumänien: __('Rumänien', 'dhsv_theme'),
  Russland: __('Russland', 'dhsv_theme'),
  'Saudi-Arabien': __('Saudi-Arabien', 'dhsv_theme'),
  Schweden: __('Schweden', 'dhsv_theme'),
  Serbien: __('Serbien', 'dhsv_theme'),
  Singapur: __('Singapur', 'dhsv_theme'),
  Slowakei: __('Slowakei', 'dhsv_theme'),
  Slowenien: __('Slowenien', 'dhsv_theme'),
  Spanien: __('Spanien', 'dhsv_theme'),
  Südafrika: __('Südafrika', 'dhsv_theme'),
  Taiwan: __('Taiwan', 'dhsv_theme'),
  'Thailand ': __('Thailand ', 'dhsv_theme'),
  'Tschechische Republik': __('Tschechische Republik', 'dhsv_theme'),
  Tunesien: __('Tunesien', 'dhsv_theme'),
  Türkei: __('Türkei', 'dhsv_theme'),
  Tuvalu: __('Tuvalu', 'dhsv_theme'),
  'Ungarn ': __('Ungarn', 'dhsv_theme'),
  Uruguay: __('Uruguay', 'dhsv_theme'),
  USA: __('USA', 'dhsv_theme'),
  Venezuela: __('Venezuela', 'dhsv_theme'),
  'Vereinigte Arabische Emirate': __(
    'Vereinigte Arabische Emirate',
    'dhsv_theme'
  ),
  Zypern: __('Zypern', 'dhsv_theme'),
}
